// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* main */
.react-datepicker {
  border-radius: 8px !important;
  border: none !important;
  /* background: orangered; */
  width: 100%;
  /* height: 90%; */
}
/* date header styling*/
.order-calendar .react-datepicker__header--custom,
.order-calendar .react-datepicker__header {
  background-color: white !important;
  /* background-color: pink !important; */
  width: 100%;
  /* height: 30% !important; */
  border: none !important;

}

/* days styling */
.react-datepicker__day,
.react-datepicker__day-name {
  font-family: "Inter" !important;
  font-weight: 400 !important;
  font-size: 0.75vw !important;
  line-height: 20px !important;
  letter-spacing: -0.18px !important;
  height: 20%;
  /* background-color: red; */
  align-self: center;
}

.react-datepicker__day,
.react-datepicker__day-names{
  height: 30%;
  margin-bottom: 0px;
  /* padding: 0 !important; */
}

.react-datepicker__day-name{
  /* border:0.05vw solid red; */
  text-align: center !important;
  width: 1.5vw !important; 
  height: 1.5vw;
  padding: .5vw;
  margin: .25vw;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 0.75vw !important;
  line-height: 1 !important;
  margin-right: 0.3vw !important;
  
  /* background-color: red; */
}



.react-datepicker__day,
.react-datepicker__time-name {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  width: 2vw; /* or use rem for better scaling */
  height: 2vw;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 0.75vw !important;
  line-height: 1 !important;
  /* background-color: red; */
}

.react-datepicker__month-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* height: 100%; */
  /* background-color: yellow; */
}

.react-datepicker__day--selected:not([aria-disabled="true"]):hover {
  background-color: #50c878 !important;
  color: white !important;
  border-radius: 50% !important;
}

.react-datepicker__day:not([aria-disabled="true"]):hover,
.react-datepicker__day--selected:not([aria-disabled="true"]),
.react-datepicker__day--range-end:not([aria-disabled="true"]),
.react-datepicker__day--range-start:not([aria-disabled="true"]) {
  background-color: #50c878 !important;
  color: white !important;
  border-radius: 3vw !important;
  padding: 1vw;
  font-weight: bold !important;
}

/* endDate select karne se phele */
.react-datepicker__day--in-selecting-range {
  background-color: #d9f99d !important;
  color: black !important;
  /* border-radius: 50% !important; */
}

.react-datepicker__day--keyboard-selected {
  background-color: #50c878 !important;
  color: white !important;
  border-radius: 50% !important;
}

/* बीच के Selected Range को Light Color दें */
.react-datepicker__day--in-range {
  background-color: #50c87826 !important;
  color: black !important;
  /* border-radius: 50% !important; */
}

.in-range {
  background-color: #50c87826 !important; /* Light Green */
  color: black !important;
}

/* week Name style */
.react-datepicker__day-name {
  color: #7b8199 !important;
}

/*select year ka style */
.year-selection {
  color: #293050 !important;
  appearance: none;
  -webkit-appearance: none;
  /* padding: 2px 2px 2px 3px; */
  /* padding: 2px 2px 2px 3px; */
  width: 3vw;
  &:focus {
    outline: none !important;
    border: none !important;
  }
}

.react-datepicker__month{
  width: 100%;
  height: 60%;
}

.react-datepicker__week{
  height: 20%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px !important;
}

.custom-arrow {
  position: absolute !important;
  left: 2vw !important;
  top: 42% !important;
  transform: translateY(-50%) !important;
  pointer-events: none !important;
  cursor: pointer !important;
}

.year-opt {
  font-family: "Inter" !important;
  font-weight: 400 !important;
  font-size: 0.8vw !important;
  line-height: 20px !important;
  letter-spacing: -0.18px !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/Setting/order/components/react-DatePicker/datePickerStyle.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;AACA,uBAAuB;AACvB;;EAEE,kCAAkC;EAClC,uCAAuC;EACvC,WAAW;EACX,4BAA4B;EAC5B,uBAAuB;;AAEzB;;AAEA,iBAAiB;AACjB;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;;EAE9B,2BAA2B;AAC7B;;;;AAIA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,UAAU,EAAE,kCAAkC;EAC9C,WAAW;EACX,2CAA2C;EAC3C,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;;EAIE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;EACtC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC,EAAE,gBAAgB;EACxD,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,UAAU;EACV;IACE,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC","sourcesContent":["/* main */\n.react-datepicker {\n  border-radius: 8px !important;\n  border: none !important;\n  /* background: orangered; */\n  width: 100%;\n  /* height: 90%; */\n}\n/* date header styling*/\n.order-calendar .react-datepicker__header--custom,\n.order-calendar .react-datepicker__header {\n  background-color: white !important;\n  /* background-color: pink !important; */\n  width: 100%;\n  /* height: 30% !important; */\n  border: none !important;\n\n}\n\n/* days styling */\n.react-datepicker__day,\n.react-datepicker__day-name {\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  font-size: 0.75vw !important;\n  line-height: 20px !important;\n  letter-spacing: -0.18px !important;\n  height: 20%;\n  /* background-color: red; */\n  align-self: center;\n}\n\n.react-datepicker__day,\n.react-datepicker__day-names{\n  height: 30%;\n  margin-bottom: 0px;\n  /* padding: 0 !important; */\n}\n\n.react-datepicker__day-name{\n  /* border:0.05vw solid red; */\n  text-align: center !important;\n  width: 1.5vw !important; \n  height: 1.5vw;\n  padding: .5vw;\n  margin: .25vw;\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 0.75vw !important;\n  line-height: 1 !important;\n  margin-right: 0.3vw !important;\n  \n  /* background-color: red; */\n}\n\n\n\n.react-datepicker__day,\n.react-datepicker__time-name {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-align: center !important;\n  width: 2vw; /* or use rem for better scaling */\n  height: 2vw;\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 0.75vw !important;\n  line-height: 1 !important;\n  /* background-color: red; */\n}\n\n.react-datepicker__month-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  /* height: 100%; */\n  /* background-color: yellow; */\n}\n\n.react-datepicker__day--selected:not([aria-disabled=\"true\"]):hover {\n  background-color: #50c878 !important;\n  color: white !important;\n  border-radius: 50% !important;\n}\n\n.react-datepicker__day:not([aria-disabled=\"true\"]):hover,\n.react-datepicker__day--selected:not([aria-disabled=\"true\"]),\n.react-datepicker__day--range-end:not([aria-disabled=\"true\"]),\n.react-datepicker__day--range-start:not([aria-disabled=\"true\"]) {\n  background-color: #50c878 !important;\n  color: white !important;\n  border-radius: 3vw !important;\n  padding: 1vw;\n  font-weight: bold !important;\n}\n\n/* endDate select karne se phele */\n.react-datepicker__day--in-selecting-range {\n  background-color: #d9f99d !important;\n  color: black !important;\n  /* border-radius: 50% !important; */\n}\n\n.react-datepicker__day--keyboard-selected {\n  background-color: #50c878 !important;\n  color: white !important;\n  border-radius: 50% !important;\n}\n\n/* बीच के Selected Range को Light Color दें */\n.react-datepicker__day--in-range {\n  background-color: #50c87826 !important;\n  color: black !important;\n  /* border-radius: 50% !important; */\n}\n\n.in-range {\n  background-color: #50c87826 !important; /* Light Green */\n  color: black !important;\n}\n\n/* week Name style */\n.react-datepicker__day-name {\n  color: #7b8199 !important;\n}\n\n/*select year ka style */\n.year-selection {\n  color: #293050 !important;\n  appearance: none;\n  -webkit-appearance: none;\n  /* padding: 2px 2px 2px 3px; */\n  /* padding: 2px 2px 2px 3px; */\n  width: 3vw;\n  &:focus {\n    outline: none !important;\n    border: none !important;\n  }\n}\n\n.react-datepicker__month{\n  width: 100%;\n  height: 60%;\n}\n\n.react-datepicker__week{\n  height: 20%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 4px !important;\n}\n\n.custom-arrow {\n  position: absolute !important;\n  left: 2vw !important;\n  top: 42% !important;\n  transform: translateY(-50%) !important;\n  pointer-events: none !important;\n  cursor: pointer !important;\n}\n\n.year-opt {\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  font-size: 0.8vw !important;\n  line-height: 20px !important;\n  letter-spacing: -0.18px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
